import DarkButton from '@/components/ui/Buttons/SecondaryButton'
import { Radio, TextField } from '@mui/material'
import classNames from 'classnames'
import Image from 'next/image'
import React, { FunctionComponent, useState } from 'react'
import { TanCreateReq } from '@/services/mobi-api/sim/types'
import useIntl from '@/utils/intl'
import { IMG_URL, phoneRegex } from '@/utils/constants'
import { useAuth } from '@/context/AuthContext'

interface Props {
  onClick: (req: TanCreateReq) => void
}

const Step1: FunctionComponent<Props> = ({ onClick }) => {
  const { isWebView } = useAuth()
  const [number, setNumber] = useState<string>('')
  const [simtype, setSimType] = useState<string>('')
  const [numberError, setNumberError] = useState(false)
  const { translate } = useIntl()

  const sim = [
    {
      type: 'ESIM',
      title: 'eSIM',
      text: translate('sim.esim.warning')
    },
    {
      type: 'SELFSIM',
      title: translate('sim.self'),
      text: translate('sim.self.warning')
    }
  ]

  const handleChangeNumber = (val: string): void => {
    setNumber(val)
    if (val.length === 8) {
      if (val.trim() !== '' && phoneRegex.test(val)) {
        setNumberError(false)
      } else {
        // setNumberError(true)
      }
    }
  }
  const handleNext = (): void => {
    if (simtype !== '' && number !== '') {
      onClick({ simtype, isdn: number, channel: isWebView ? 'MBAPP' : 'MOBIWEB' })
    }
  }
  return (
    <div className='bg-surfaceInverse rounded-xl md:shadow w-full h-full md:h-[75vh] md:w-fit flex flex-col justify-start overflow-auto relative'>
      <div className='sticky top-0 z-50 md:p-6 p-4 md:border-b bg-surfaceInverse border-secondaryMidStroke'>
        <TextField
          value={number}
          id='outlined-basic' label={translate('phoneNumber')} variant='outlined' type='number' onChange={(e) => { e.target.value.length < 9 && handleChangeNumber(e.target.value) }}
          className='w-full rounded-lg border-secondaryMainStroke bg-surfaceInverse text-textHigh md:w-96'
          InputLabelProps={{
            style: { color: 'var(--color-text-textHigh)' }
          }}
          inputProps={{ inputMode: 'numeric' }}
          InputProps={{
            style: {
              color: 'var(--color-text-textHigh)',
              '&::placeholder': {
                color: 'var(--color-text-secondaryHighStroke)'
              }
            } as any
          }}
          sx={{
            '& fieldset': {
              borderRadius: '8px'
            }
          }}
        />
        <p className={classNames('text-sm text-[#FF0000] py-1 pl-2', numberError ? 'flex' : 'hidden')}>{translate('error.isdnError')}</p>
      </div>
      <div className='flex flex-grow flex-col md:p-6 p-4 overflow-auto md:h-full'>
        {
          number.length === 8 && phoneRegex.test(number)
            ? (
              <div className='w-full md:w-96'>
                <div className='flex items-start gap-4 p-2 border border-[#F4A610] bg-[#FEFCF5] rounded-lg'>
                  <Image width={32} height={32} draggable={false} src={IMG_URL + '/uploads/icons/warning.svg'} alt='!' />
                  <div>
                    <p className='text-[#78350F] font-semibold text-sm'>{translate('sim.selectType')}</p>
                    <p className='text-[#78350F] text-sm mt-2'>{translate('sim.warning')}</p>
                  </div>
                </div>
                <div className='flex flex-col gap-4 mt-4'>
                  {sim.map((sim, index) => (
                    <div key={index} className={classNames('border  rounded-xl md:p-4 p-2 flex gap-4 items-center cursor-pointer', simtype === sim.type ? 'border-red-600' : 'border-secondaryMidStroke')} onClick={() => setSimType(sim.type)}>
                      <Radio checked={simtype === sim.type} color='error' className='text-textHigh' />
                      <div className='flex flex-col gap-1'>
                        <span className='text-textHigh font-bold'>{sim.title}</span>
                        <p className='text-textMid font-medium text-sm'>{sim.text}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              )
            : <></>
        }
      </div>
      <div className='fixed md:sticky bottom-0 right-0 left-0 z-50 md:p-6 p-4 border-t bg-surfaceInverse border-secondaryMidStroke'>
        <DarkButton fullwidth disabled={simtype === undefined || numberError || number.length < 8} onClick={handleNext}>{translate('continue')}</DarkButton>
      </div>
    </div>
  )
}
export default Step1
